/**
 * Generic utility functions for handling filters
 */

import { CrudFilters, CrudOperators } from '@refinedev/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createFilters = <T extends Record<string, any>>(
  filterParams: T,
  operator: Exclude<CrudOperators, 'or' | 'and'> = 'eq'
): CrudFilters => {
  const filters: CrudFilters = [];

  for (const [key, value] of Object.entries(filterParams)) {
    // Handle array filters (like classroom_id[])
    const field = key.includes('[]') ? `filter[${key}][]` : `filter[${key}]`;

    filters.push({
      field,
      operator,
      value
    });
  }

  return filters;
};
